import React from "react";
import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import LGModalCrud from "../LGCrud/LGModalCrud";
import { useCompany } from "../../contexts/CompanyContext";
import TransformationForm from "./TransformationForm.tsx";
import dayjs from "dayjs";
import { deleteTransformation, getTransformationList } from "../../api/transformations/index.ts";

const TransformationTable = () => {
  const { selectedCompany } = useCompany();

  if (!selectedCompany) {
    return (
      <Box p={4}>
        <Typography>Seleccione una compañía primero</Typography>
      </Box>
    );
  }

  const transformationCrudProps = {
    fetchFunction: getTransformationList,
    deleteFunction: deleteTransformation,
    data: { companyId: selectedCompany.id },
    detailMenu: [],
    columns: [
      { field: "id", headerName: "ID", flex: 0.05 },
      {
        field: "existingProduct",
        headerName: "Producto Existente",
        flex: 0.2,
        valueGetter: (value, row) => {
          return row.existingProduct ? `${row.existingProduct.code} - ${row.existingProduct.description}` : "";
        },
      },
      {
        field: "warehouse",
        headerName: "Almacén",
        flex: 0.15,
        valueGetter: (value, row) => {
          return row.warehouse ? row.warehouse.name : "";
        },
      },
      {
        field: "quantity",
        headerName: "Cantidad",
        flex: 0.1,
        valueGetter: (value, row) => {
          return row.quantity || 0;
        },
      },
      {
        field: "expectedProducts",
        headerName: "Productos Esperados",
        flex: 0.3,
        renderCell: (params) => {
          const inboundItems = params.row.inbound?.inboundItems || [];
          return (
            <Stack direction="column" spacing={1} flexWrap="wrap">
              {inboundItems.map((item, index) => (
                <Box key={index} sx={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="caption" noWrap>
                    {item.product?.code || item.productId} - {item.product?.description || item.description} (Cant: {item.quantityDelivered})
                  </Typography>
                </Box>
              ))}
            </Stack>
          );
        },
      },
      {
        field: "createdAt",
        headerName: "Fecha de Transformación",
        flex: 0.2,
        valueFormatter: (value) => {
          if (!value) return "-";
          return dayjs(value).format("YYYY-MM-DD");
        },
      },
    ],
    addModalData: {
      header: "Nueva Transformación",
      body: <TransformationForm onSubmit={() => { }} />,
    },
    editModalData: {
      header: "Editar Transformación",
      body: <TransformationForm onSubmit={() => { }} />,
    },
    actions: ["create", "delete", "detail"],
    customButtons: [],
  };

  return <LGModalCrud props={transformationCrudProps} />;
};

export default TransformationTable; 